export const ADMIN_ROUTES = {
  challenges: "/admin/manage/challenges",
  challengesWithStatus: (status: string) =>
    `${ADMIN_ROUTES.challenges}?status=${encodeURIComponent(status)}`,
  challengeDetail: (id: string) =>
    `/admin/manage/challenges/view?id=${encodeURIComponent(id)}`,
  challengePendingClips: (id: string) =>
    `${ADMIN_ROUTES.challengeDetail(id)}&section=pending-clips`,
  streamers: "/admin/manage/streamers",
  users: "/admin/manage/users",
  reports: "/admin/reports",
} as const
